const _ = require('lodash');
const TableSelector = (function() {

  const $document = nifty.document;
  const head = {
    selector: 'th.checkbox-cell input[type=checkbox]',
    get: $('th.checkbox-cell input[type=checkbox]'),
    handler: function(event) {
      const checkbox = $(event.target);
      const label = checkbox.closest('label');
      const table = checkbox.closest('table');

      const isMany = event.target.dataset.isMany;
      const btnDetachNormal = $('.detach-normal');
      const btnDetachMany = $('.detach-many');

      validateIsMany(isMany, btnDetachNormal, btnDetachMany, label.niftyCheck('isChecked'));

      if (label.niftyCheck('isChecked')) {
        table.find('td.checkbox-cell label').niftyCheck('toggleOn');
      } else {
        table.find('td.checkbox-cell label').niftyCheck('toggleOff');
      }
    }
  };

  function validateIsMany(isMany, btnDetachNormal, btnDetachMany, isChecked) {
    if (btnDetachMany.length > 0 && btnDetachNormal.length > 0 && isMany) {
      if (isChecked) {
        btnDetachMany.css('display', 'block');
        btnDetachNormal.css('display', 'none');
      } else {
        btnDetachMany.css('display', 'none');
        btnDetachNormal.css('display', 'block');
      }
    }
  }

  const row = {
    selector: 'td.checkbox-cell input[type=checkbox]',
    get: $('td.checkbox-cell input[type=checkbox]'),
    handler: function(event) {
      const checkbox = $(event.target);
      const label = checkbox.closest('label');
      const entity = $(checkbox).data('entity') ?  '#' + $(checkbox).data('entity') : '';
      if (!label.niftyCheck('isChecked')) {
        $('.detach-normal').css('display', 'block');
        $('.detach-many').css('display', 'none');
        head.get.prop('checked', false).closest(`${entity} label`).removeClass('active');
      }
    }
  }

  function TableSelector() {
    $document.on('change', head.selector, head.handler);
    $document.on('change', row.selector, row.handler);
  }

  TableSelector.prototype.selectedValues = function() {
    return _.map(row.get.filter(':checked'), 'value');
  }

  TableSelector.prototype.selectedTotal = function() {
    return row.get.filter(':checked').length;
  };

  TableSelector.prototype.isHeadChecked = function() {
    return head.get.closest('label').niftyCheck('checked');
  };

  TableSelector.prototype.getHead = function() {
    return head.get;
  };

  TableSelector.prototype.getBody = function() {
    return row.get;
  };

  TableSelector.prototype.getInput = function(id) {
    const input = row.get.filter('[value="' + id + '"]');

    if(!input.length) {
      throw new Error('Input "' + id + '" not found!');
    }

    return input;
  };

  TableSelector.prototype.getRow = function(id) {
    const _row = row.get.filter('[value="' + id + '"]').closest('tr');

    if(!_row.length) {
      throw new Error('Row "' + id + '" not found!');
    }

    return _row;
  };

  TableSelector.prototype.refresh = function() {
    row.get = $(row.selector);
    head.get = $(head.selector);

    return this;
  };

  TableSelector.prototype.getInfo = function(id) {
    return this.getInput(id).data('info');
  };

  TableSelector.prototype.remove = function(id) {
    this.getRow(id).remove();
    this.refresh();

    return this;
  };

  TableSelector.prototype.selectAll = function() {
    row.get.each(function(n, el) {
      $(el).closest('label').niftyCheck('toggleOn');
    });
    head.get.closest('label').niftyCheck('toggleOn');

    return this;
  };

  TableSelector.prototype.unselectAll = function() {
    row.get.each(function(n, el) {
      $(el).closest('label').niftyCheck('toggleOff');
    });
    head.get.closest('label').niftyCheck('toggleOff');

    return this;
  };

  TableSelector.prototype.selectByValue = function(id) {
    this.getRow(id).closest('label').niftyCheck('toggleOn');

    return this;
  };

  return TableSelector;
}());

module.exports = TableSelector;
